import React, { useContext } from 'react';
import { SitewidePromoBar } from '@vp/sitewide-promo-bar';
import '@vp/sitewide-promo-bar/build/css/main.css';
import SiteContext from '../contexts/SiteContext';
import { IdentityContext } from '../contexts/IdentityContext';
import useFeature from '../../hooks/useFeature';
import {
  CART_PAGE_SECTION,
  CART_PAGE_STAGE,
  CART_PAGE_NAME,
} from '../../constants/cartui';

export const PromoBar = () => {
  const {
    tracking: { brand: trackingTenant },
    uiLocalization: { locale },
  } = useContext(SiteContext);
  const { auth } = useContext(IdentityContext);
  const enableSiteWidePromoBar = useFeature('enableSiteWidePromoBar');

  if (!auth || !enableSiteWidePromoBar) {
    return null;
  }

  return (
    <SitewidePromoBar
      tenant={trackingTenant}
      locale={locale}
      promoBarConfig={{ type: 'default' }}
      canonicalId={auth.getCanonicalId()}
      accessToken={auth.getToken()}
      pageType="cart"
      pageId="cart"
      trackingConfiguration={{
        pageName: CART_PAGE_NAME,
        pageSection: CART_PAGE_SECTION,
        pageStage: CART_PAGE_STAGE,
      }}
    />
  );
};
